// Lib
import * as Immutable from 'immutable';

// Constants
import { THEMES } from '../../user/account/accountModal/interface/themeSettings/themeConstants';
import { HYBRID_APP_CHANGE_THEME } from './hybridAppStoreConstants';

const initialState = Immutable.Map({
    nativeTheme: THEMES.LIGHT,
});

/**
 * NOTE: This reducer is currently used by the Electron app.
 *  It should be reconsidered when rebuilding the desktop app.
 */
export default (state = initialState, action) => {
    switch (action.type) {
        case HYBRID_APP_CHANGE_THEME:
            return state.set('nativeTheme', action.theme);
        default:
            return state;
    }
};
